(() => {





  // 変数 ========== common
  let windowBreakPoint = 768;
  let windowDefaultWidth = window.innerWidth;

  // 変数 ========== slider
  let sliderBg = document.getElementById('sliderBg');

  // 変数 ========== header
  let headerLogo = document.getElementById('headerLogo');
  let headerLogoImg = document.getElementById('headerLogoImg');
  let headerNav = document.getElementById('headerNav');
  let headerNavFlag = false;
  let headerBtnOpen = document.getElementById('headerBtnOpen');
  let headerBtnClose = document.getElementById('headerBtnClose');

  // let blurTargetDefault = document.querySelector('.idx-main_bg');

  // 変数 ========== footer
  let footerBtnCorporate = document.getElementById('footerBtnCorporate');
  let footerBtnRecruit = document.getElementById('footerBtnRecruit');

  // 関数 ========== HoverChangeImg
  const HoverChangeImg = (changeTarget, changeSrc, baseSrc) => {
    function AddImgOpacity() {
      changeTarget.className = 'item-anchor_img-opacity';
    }
    function RemoveImgOpacity() {
      changeTarget.className = '';
    }
    function ChangeImgOver() {
      changeTarget.setAttribute('src', changeSrc);
    };
    function ChangeImgLeave() {
      changeTarget.setAttribute('src', baseSrc);
    };
    changeTarget.addEventListener('mouseover', () => {
      setTimeout(AddImgOpacity, 0);
      setTimeout(ChangeImgOver, 295);
      setTimeout(RemoveImgOpacity, 300);
    }, false);
    changeTarget.addEventListener('mouseleave', () => {
      setTimeout(AddImgOpacity, 0);
      setTimeout(ChangeImgLeave, 295);
      setTimeout(RemoveImgOpacity, 300);
    }, false);
  }





  window.addEventListener('load', () => {



    if(windowDefaultWidth > windowBreakPoint){


      window.addEventListener('scroll', () => {
        let scrollVolume = window.pageYOffset;
        if(scrollVolume > 90){
          headerLogo.className = 'st-header_logo st-header_logo-small';
          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-black.svg');
          headerNav.className = 'st-header_nav st-header_nav-hidden st-header_nav-shadow';
        } else {
          headerLogo.className = 'st-header_logo';
          headerNav.className = 'st-header_nav st-header_nav-hidden';
          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-white.svg');
        }
      }, false);

      // blurTargetDefault.setAttribute('style', 'height:' + windowDefaultWidth * 0.45 + 'px');

      HoverChangeImg(footerBtnCorporate, '/assets/images/pc/footer_btn-corporate-hover.png', '/assets/images/pc/footer_btn-corporate.png');
      HoverChangeImg(footerBtnRecruit, '/assets/images/pc/footer_btn-recruit-hover.png', '/assets/images/pc/footer_btn-recruit.png');


    } else {


      headerBtnOpen.addEventListener('click', () => {
        if(!headerNavFlag){
          headerNav.className = 'st-header_nav st-header_nav-visible';
          headerNavFlag = true;
        }
      }, false);

      headerBtnClose.addEventListener('click', () => {
        if(headerNavFlag){
          headerNav.className = 'st-header_nav st-header_nav-hidden';
          headerNavFlag = false;
        }
      }, false);


    }



  }, false);





  window.addEventListener('resize', () => {


    let windowResizeWidth = window.innerWidth;



    if(windowResizeWidth > windowBreakPoint){


      window.addEventListener('scroll', () => {
        let scrollVolume = window.pageYOffset;
        if(scrollVolume > 90){
          headerLogo.className = 'st-header_logo st-header_logo-small';
          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-black.svg');
          headerNav.className = 'st-header_nav st-header_nav-hidden st-header_nav-shadow';
        } else {
          headerLogo.className = 'st-header_logo';
          headerNav.className = 'st-header_nav st-header_nav-hidden';
          headerLogoImg.setAttribute('src', '/assets/images/common/img-logo-white.svg');
        }
      }, false);

      // blurTargetDefault.setAttribute('style', 'height:' + windowResizeWidth * 0.45 + 'px');

      HoverChangeImg(footerBtnCorporate, '/assets/images/pc/footer_btn-corporate-hover.png', '/assets/images/pc/footer_btn-corporate.png');
      HoverChangeImg(footerBtnRecruit, '/assets/images/pc/footer_btn-recruit-hover.png', '/assets/images/pc/footer_btn-recruit.png');


    } else {


      headerBtnOpen.addEventListener('click', () => {
        if(!headerNavFlag){
          headerNav.className = 'st-header_nav st-header_nav-visible';
          headerNavFlag = true;
        }
      }, false);

      headerBtnClose.addEventListener('click', () => {
        if(headerNavFlag){
          headerNav.className = 'st-header_nav st-header_nav-hidden';
          headerNavFlag = false;
        }
      }, false);


    }



  }, false);



  // var blurTarget = $('#blurTarget');
  // blurTarget.backgroundBlur('../assets/images/common/main_img-visual-47heroines.png');
  // blurTarget.backgroundBlur({
  //   imageURL: '../assets/images/common/main_img-visual-47heroines.png',
  //   imageClass: 'idx-main_bg-blur',
  //   blurAmount: 4
  // });

  // var chromePointerEvents = typeof PointerEvent === 'function'; if (chromePointerEvents) { if (orig.pointerId === undefined) { return; } }
  // touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig];

  var sliderImages       = $('.idx-main_slider_item_img');
  var sliderImagesLength = sliderImages.length;
  var sliderBack         = [];
  for(let i = 0; i < sliderImagesLength; i++){
    var baseImage = sliderImages.eq(i);
    var baseText  = baseImage.attr('src');
    var fixedText = baseText.replace('/assets', './assets');
    sliderBack.push(fixedText);
  }

  if ($(window).width() > 768) {
    $("#sliderMain").bxSlider({
      auto: true,
      infiniteLoop: true,
      responsive: true,
      speed: 800,
      displaySlideQty: 3,
      pager: true,
      slideWidth: 1200,
      moveSlides: 1,
      pause: 5000,
      touchEnabled: false,
      onSlideBefore: function(e, oI, nI){
        sliderBg.setAttribute('style', 'background-image: url(' + sliderBack[nI] + ');');
      }
    });
  } else {
    $("#sliderMain").bxSlider({
      auto: true,
      infiniteLoop: true,
      responsive: true,
      speed: 800,
      displaySlideQty: 3,
      pager: true,
      slideWidth: 1200,
      moveSlides: 1,
      pause: 5000,
      touchEnabled: true,
      onSlideBefore: function(e, oI, nI){
        sliderBg.setAttribute('style', 'background-image: url(' + sliderBack[nI] + ');');
      }
    });
  }

  $(document).on('mousedown','.bx-viewport a',function(){
    var $this = $(this),
        myHref = $this.attr('href'),
        myTarget = $this.attr('target');
    if(myTarget === '_blank'){
      window.open(myHref);
    }else{
      window.location.href = myHref;
    }
  });


  $("a[href^=#]").on("click", function(){
    var linkSpeed = 600;
    var linkHref = $(this).attr("href");
    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkTimeWidth = $(window).width();
    var linkDifference;
    if(linkTimeWidth > 768){
      linkDifference = 90;
    } else {
      linkDifference = linkTimeWidth * 0.15625;
    }
    var linkPosition = linkTarget.offset().top - linkDifference;
    $("html, body").animate({scrollTop: linkPosition}, linkSpeed, "swing");
    return false;
  });





})();



// WEBPACK FOOTER //
// ./src/assets/js/script.js